//工艺

import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

import TechnologyPage from "@/views/model/technology/technologyPage.vue";
import TechnologyChange from "@/views/model/technology/technologyChange.vue";
import TechnologyBOM from "@/views/model/technology/technologyBOM.vue";
import TechnologyRelatedItem from "@/views/model/technology/technologyRelatedItem.vue";
import TechnologyRelatedResource from "@/views/model/technology/technologyRelatedResource.vue";
import TechnologyRelatedTechnology from "@/views/model/technology/technologyRelatedTechnology.vue";
import TechnologyHistory from "@/views/model/technology/technologyHistory.vue";

export const Technology = {
  path: "/technologyPage",
  component: TechnologyPage,
  children: [
    {
      path: "/technologyTitleBlock",
      component: PageInfo,
    },
    {
      path: "/technologyChange",
      name: "technologyChange",
      component: TechnologyChange,
    },
    {
      path: "/technologyBOM",
      name: "technologyBOM",
      component: TechnologyBOM,
    },
    {
      path: "/technologyRelatedItem",
      name: "technologyRelatedItem",
      component: TechnologyRelatedItem,
    },
    {
      path: "/technologyRelatedResource",
      name: "technologyRelatedResource",
      component: TechnologyRelatedResource,
    },
    {
      path: "/technologyRelatedTechnology",
      name: "technologyRelatedTechnology",
      component: TechnologyRelatedTechnology,
    },
    {
      path: "/technologyAttachment",
      name: "technologyAttachment",
      component: ItemAttachment,
    },
    {
      path: "/technologyHistory",
      name: "technologyHistory",
      component: TechnologyHistory,
    },
  ],
};
